import { ChangeDetectionStrategy, Component, Input} from '@angular/core';
import { Resource } from 'src/app/api/models';
import { ResourceBadge } from 'src/app/calendar/shared/models/resource-badge.model';

@Component({
    selector: 'diana-person-resource-badge',
    templateUrl: './person-resource-badge.component.html',
    styleUrls: ['./person-resource-badge.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PersonResourceBadgeComponent {
  constructor() {}

  @Input()
  set resources(res: Resource[] | undefined ) {
    this.createPersonBadges(res);
  }

  @Input()
  iconSize = '14px';

  resourceBadges: ResourceBadge[] = [];

  trackByBadge(index: number) {
    return index;
  }

  createPersonBadges(resources: Resource[] | undefined): void {
    let badges: ResourceBadge[] = [];

    if (resources && resources.length > 0) {
      this.personResources(resources).forEach(persRes => {
        const splitName = persRes?.name?.trim().split(' ');
        if (!splitName) {
          return;
        }
        const initials =
          splitName.length === 1
            ? `${splitName[0].charAt(0).toUpperCase()}`
            : `${splitName[0].charAt(0).toUpperCase()}${splitName[
                splitName.length - 1
              ]
                .charAt(0)
                .toUpperCase()}`;

        badges.push({
          initials,
          color: persRes.color ?? '#000'
        });
      });
    }
    this.resourceBadges = badges;
  }

  private personResources(resources: Resource[]): Resource[] {
    return resources?.filter(res => res.type === 'PERSONAL') ?? [];
  }
}
